// extracted by mini-css-extract-plugin
module.exports = {"information":"information__MUuSsTNfRa9Le","icon":"icon__rF7Wd2sMhdXaa","text":"text__RJAf5JB2w+2+b"};